const IP = 'http://app.hoilhtn.tinhdoandongnai.com:1003'
// const IP = 'http://localhost:1003'

export class AppConstants {
    private static API_BASE_URL = IP + '/';
    private static API_BASE_URL2 = IP;
    public static API_URL = AppConstants.API_BASE_URL + "api/";
    public static API_URL2 = AppConstants.API_BASE_URL2;
}